export const checkDateRangeSupport = (iframe: HTMLIFrameElement) => {
    if (iframe.contentWindow) {
        if (iframe.contentWindow.document.getElementById('DateRange')) {
            return true;
        }
    }
    return false;
};

export const openDateRangeDialog = (name: string) => {
    const activateDateDialog = (
        window as any as Window & {activateDateDialog?: (name: string) => void}
    ).activateDateDialog;
    if (activateDateDialog) {
        activateDateDialog(name);
    }
};
